<template>
	<div class="UploadItemMaster">
		<!-- <el-button
			icon="el-icon-arrow-left"
			type="warning"
			style="width:auto;"
			size="mini"
			@click="$router.go(-1)"
		>
			Previous Page
		</el-button> -->
		<div class="UploadItemMaster-card">
			<div>
				<el-row :gutter="20" class="top-margin">
					<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="12">
						<p class="input-label">Applicable to all Stores?</p>
						<el-checkbox
							v-model="checked"
							style="display: block;height: 40px;margin-bottom: 20px;width: 100%;"
							:border="true"
							size="medium"
							true-label="all"
							false-label="none"
							@change="displayMassageLocation(checked)"
						>
							<p v-if="checked == 'all'">
								&nbsp;&nbsp;Yes
							</p>
							<p v-if="checked == 'none'">
								&nbsp;&nbsp;&nbsp;No
							</p>
						</el-checkbox>
					</el-col>
					<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="12">
						<p class="input-label">If Not Select Location</p>
						<div>
							<el-select
								v-model="outletsSelected"
								class="custom-input"
								style="width: 100%;"
								:disabled="checked == 'all'"
								multiple
								collapse-tags
								placeholder="Select"
							>
								<el-option
									v-for="(outlet, index) in outlets"
									:key="index"
									:label="outlet.name"
									:value="outlet.id"
								/>
							</el-select>
						</div>
					</el-col>
					<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="12">
						<p class="input-label">Select Application <span style="color: red;">*</span></p>
						<div>
							<el-select
								v-model="applicationSelected"
								class="custom-input"
								style="width: 100%;"
								collapse-tags
								multiple
								placeholder="Select"
								@change="selectApplication(applicationSelected)"
							>
								<el-option
									v-for="(obj, index1) in applicationList"
									:key="index1"
									:label="obj.name"
									:value="obj.id"
								/>
							</el-select>
						</div>
					</el-col>
					<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="12">
						<div
							v-if="selectCsvType === 'workforceArticleMaster'"
							class="if-not mt-6"
						>
							<a
								href="https://nymbleup-public.s3.ap-south-1.amazonaws.com/templates/Nymble_WF_Article_master.csv"
							>
								<BaseButton buttonclass="btn p-2 text-xs">
									Download Item Master Template
								</BaseButton>
							</a>
						</div>
						<div v-else class="if-not mt-6">
							<a
								href="https://s3.ap-south-1.amazonaws.com/nymbleup-public/templates/Nymble_Article_Master.csv"
							>
								<BaseButton buttonclass="btn p-2 text-xs">
									Download Item Master Template
								</BaseButton>
							</a>
						</div>
					</el-col>
				</el-row>
				<div style="border-bottom: 1px solid #ccc; margin: 10px 0;" />
				<el-row :gutter="20">
					<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
						<div style="display:flex;" class="custom-input">
							<label
								style="padding:8px"
								:class="
									applicationSelected == '' ? 'disabled_input btn p2' : 'btn p2'
								"
							>
								Upload Csv
								<input
									id="articleMaster"
									:disabled="applicationSelected == ''"
									name="File Upload"
									accept=".csv"
									type="file"
									@change="uploadItemMasterCsv($event, selectCsvType)"
								/>
							</label>
						</div>
					</el-col>
					<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
						<div class="custom-input">
							<BaseButton
								buttonclass="btn p-2 text-xs"
								:disabled="applicationSelected == ''"
							>
								Add Ingredient
							</BaseButton>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
import { UploadCsv } from "../../../../../mixins/processCsvFunctions/uploadCsv.mixin";
import CommonService from "../../../../services/commonService";

export default {
	name: "UploadItemMaster",
	mixins: [UploadCsv],
	data() {
		return {
			checked: "all",
			outlets: {},
			outletsSelected: [],
			value: "",
			applicationSelected: "",
			selectCsvType: "",
			applicationList: [
				{ id: "workforceArticleMaster", name: "Workforce planning" },
				{ id: "articleMaster", name: "Inventory planning" }
			]
		};
	},
	computed: {
		selectedOutletId: {
			get: function() {
				return this.checked == "all" ? this.checked : this.outletsSelected;
			},
			set: function(newValue) {
				this.checked = "all";
				this.outletsSelected = [];
			}
		},
		showLocationError() {
			return this.checked === "none" && this.outletsSelected.length === 0;
		}
	},
	watch: {
		checked: function(val) {
			if (val == "all") {
				this.outletsSelected = [];
			}
		}
	},
	created() {
		var type = [
			"store",
			"warehouse",
			"head_office",
			"distribution_centre",
			"regional_office",
			"central_kitchen"
		];
		// var not = "vender";
		this.getOutlets({ get_all: true, type: type });
	},
	methods: {
		selectApplication(applicationSelected) {
			if (applicationSelected.toString() === "articleMaster") {
				this.selectCsvType = "articleMaster";
			} else if (applicationSelected.toString() === "workforceArticleMaster") {
				this.selectCsvType = "workforceArticleMaster";
			} else {
				this.selectCsvType = "articleMaster";
			}
		},
		displayMassageLocation(checked) {
			if (checked === "none") {
				this.$notify.error({
					title: "Warning",
					message: "Please select location.",
					type: "error"
				});
			}
		},
		uploadItemMasterCsv(file, fileName) {
			// console.log("this.selectedOutletId", this.selectedOutletId);
			if (this.showLocationError) {
				this.$notify.error({
					title: "Error",
					message: "Please select outlet/outlets",
					type: "error"
				});
			} else {
				this.getCsvFile(file, fileName);
				// this.uploadCsv(file, "article_master", this.selectedOutletId, []);
			}
		},
		getOutlets(args) {
			CommonService.getOutlets(args)
				.then(response => {
					if (response.status == 200) {
						let outlet = JSON.parse(response.data);
						this.outlets = outlet.filter(el => el.type == "store" || el.type == "central_kitchen");
						// this.outlets = outlets.reduce((acc, v) => {
						// 	acc[v.name] = v.id;
						// 	return acc;
						// }, {});
					}
				})
				.catch(error => {
					console.log("error", error);
				});
		}
	}
};
</script>

<style lang="scss" scoped>
.disabled_input {
	color: #c0c4cc !important;
}
@import "./UploadArticleMaster.scss";
</style>
